import type {
  SessionSnapshot,
  SessionState,
  UserProfile,
} from '@/core/auth/session/session.types'

const listeners = new Set<() => void>()

let sessionState: SessionState = {
  status: 'loading',
  profile: null,
  expiresAtUtc: null,
}

let sessionSnapshot: SessionSnapshot = toSnapshot(sessionState)

function emitChange() {
  listeners.forEach((listener) => listener())
}

function toSnapshot(state: SessionState): SessionSnapshot {
  return {
    status: state.status,
    isAuthenticated: state.status === 'authenticated' && Boolean(state.profile),
    profile: state.profile,
    expiresAtUtc: state.expiresAtUtc,
  }
}

export function setSession(profile: UserProfile, expiresAtUtc: string) {
  sessionState = {
    status: 'authenticated',
    profile,
    expiresAtUtc,
  }
  sessionSnapshot = toSnapshot(sessionState)
  emitChange()
}

export function clearSessionState() {
  sessionState = {
    status: 'guest',
    profile: null,
    expiresAtUtc: null,
  }
  sessionSnapshot = toSnapshot(sessionState)
  emitChange()
}

export function getSessionSnapshot(): SessionSnapshot {
  return sessionSnapshot
}

export function subscribeSession(listener: () => void): () => void {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}
